@import './pn-site-footer-common.scss';
@import '../../../globals/main.scss';

pn-site-footer-col:not([theme='dotcom']) {
  min-width: 15em;
  padding: 2.5em 1.5rem 0;
  width: 100%;

  @media screen and (min-width: $sitefooter-media-phoneheight) {
    width: 50%;
  }

  @media screen and (min-width: $sitefooter-media-smalldesktop) {
    max-width: 25%;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 1.6rem;
  }

  a {
    text-decoration: none;
    width: fit-content;

    .pn-h2 {
      color: $black;
    }
  }

  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }
}

pn-site-footer-col[theme='dotcom'] {
  width: 100%;
  display: flex;
  flex-direction: column;

  & * {
    color: $white;
  }

  @media screen and (min-width: $min-width-md) {
    width: 33%;
    padding-left: 0.8rem;
    padding-right: 0.8rem;

    &:nth-child(1),
    &:nth-child(4) {
      padding-left: 0;
    }

    &:nth-child(3),
    &:nth-child(5) {
      padding-right: 0;
    }
  }

  @media screen and (min-width: 1024px) {
    width: 20%;
    padding-left: 1.6rem;
    padding-right: 1.6rem;

    &:nth-child(1) {
      width: 20%;
      padding-left: 0;
    }

    &:nth-child(4) {
      padding-left: 1.6rem;
    }

    &:nth-child(3) {
      padding-right: 1.6rem;
    }

    &:nth-child(5) {
      padding-right: 0;
    }
  }

  .pn-h2 {
    margin-bottom: 1rem;
    font-weight: 700;
    font-size: 2rem;
    line-height: 2.2rem;

    @media screen and (min-width: $min-width-xl) {
      font-size: 2.4rem;
      line-height: 2.64rem;
    }
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    margin-bottom: 1.4rem;

    li {
      margin-bottom: 1rem;
    }
  }

  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    width: fit-content;
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 2.24rem;
    min-height: 26px;

    .pn-h2 {
      color: $white;
    }
  }

  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  div {
    min-height: 150px;
    margin-bottom: 1.4rem;

    p:nth-child(odd) {
      font-weight: 500;
    }
  }
}
